export const avatarKeys = {
  all: ["avatars"] as const,
};
